module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-premium@2-7cb0d2a9365950aa350898f6c8aec922.jpg";